module.exports = __webpack_public_path__ + "img/synaxy_all_white.2711d728.svg";